/* La Caza Cali — PDP light switch fold (round 5.3, owner fix).
 *
 * Round 5.2 tried docking the switch below the image on mobile; the
 * owner tested on a real phone and wants it back OVER the image
 * (bottom-right, 12px inset) at every width — this file no longer
 * moves the .lp__bar node anywhere. Instead, 2.5s after the light
 * slide becomes visible or after the last pointer interaction, the
 * switch folds (assets/lacaza-uplift.css .lp__switch--foldable —
 * capsule retracts into the glowing knob, ~44px) so the lamp's base is
 * visible underneath. Tapping/clicking the folded knob both expands it
 * AND toggles the lights in the SAME tap — that's not special-cased
 * here, it falls out naturally: the 'click' listener below (which only
 * un-folds) and assets/lacaza-light-preview.js's own 'click' listener
 * (which toggles on/off) are both bound to the same button and both
 * fire on one tap.
 */
(function () {
  'use strict';

  var FOLD_DELAY = 2500;

  function initFold(slide) {
    var bar = slide.querySelector('.lp__bar');
    var sw = slide.querySelector('.lp__switch');
    if (!sw) return;
    sw.classList.add('lp__switch--foldable');

    // Round 6.2: separate folded-knob <button> (snippets/lacaza-light
    // -preview.liquid renders it disabled/inert; only a folding slide
    // arms it). Tapping it unfolds AND toggles in one tap by
    // re-dispatching a click on the real switch.
    var knob = slide.querySelector('.lp__knob-fold');
    if (knob) knob.disabled = false;

    var timer = null;

    function setFolded(folded) {
      sw.classList.toggle('is-folded', folded);
      if (bar) bar.classList.toggle('lp__bar--folded', folded);
      if (knob) {
        knob.setAttribute('aria-hidden', folded ? 'false' : 'true');
        knob.tabIndex = folded ? 0 : -1;
      }
    }

    function clearFoldTimer() {
      if (timer) { window.clearTimeout(timer); timer = null; }
    }

    function scheduleFold() {
      clearFoldTimer();
      timer = window.setTimeout(function () {
        // Owner fix: the folded knob is now force-centered regardless
        // of on/off (assets/lacaza-uplift.css), so it no longer needs
        // to be skipped in the OFF state — it used to clip away
        // entirely when the fold relied on the knob's natural ON-state
        // resting position.
        setFolded(true);
      }, FOLD_DELAY);
    }

    function wake() {
      setFolded(false);
      scheduleFold();
    }

    ['pointerdown', 'pointermove', 'touchstart', 'mouseenter', 'click', 'focus'].forEach(function (evt) {
      sw.addEventListener(evt, wake, { passive: true });
    });
    if (knob) {
      knob.addEventListener('click', function (e) {
        e.preventDefault();
        wake();
        sw.click();
      });
    }

    if ('MutationObserver' in window) {
      new MutationObserver(function () {
        if (slide.classList.contains('is-active')) wake();
        else { setFolded(false); clearFoldTimer(); }
      }).observe(slide, { attributes: true, attributeFilter: ['class'] });
    }

    if (slide.classList.contains('is-active')) wake();
  }

  function init() {
    document.querySelectorAll('[data-pdp-media-type="light-preview"]').forEach(initFold);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
